/**
 @ngdoc service
 @name mapBusinessrecordTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapBusinessrecordTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            tileFactory.addFieldToColumn1(tileFactory.field.newField('id'));

            tileFactory.addFieldToColumn1(tileFactory.field.newRankedInactiveFieldAjax(
                'phoneNo',
                [['phoneStrike', 'phoneStrike'], ['unsubscribedFromCalls', 'unsubscribedFromCalls']],
                'actionLogURI','logPhoneCall'
            ));

            tileFactory.addFieldToColumn2(tileFactory.field.newAddressField('addressShort'));

            if(rawTileData.distanceFromSearch != null || rawTileData.distanceFromSearch != undefined) {
                tileFactory.addFieldToColumn2(tileFactory.field.newField('distanceFromSearch'));
            }

            if(rawTileData.openJobCount > 0) {
              tileFactory.addFieldToColumn2(tileFactory.field.newField('openJobCount'));
            }

            // Additions to first column
            var industrySector = undefined;
            if(rawTileData.industrySector && rawTileData.industrySubSector){
                industrySector = rawTileData.industrySector ? rawTileData.industrySector : '';
                industrySector += industrySector.length && rawTileData.industrySubSector ? ' - ' + rawTileData.industrySubSector : '';
            }
            tileFactory.addFieldToColumn3({label: objectTilesLabels.industrySector.label, value: industrySector});

            tileFactory.addFieldToColumn3(tileFactory.field.newField('customerAccountManager'));

            tileFactory.addFieldToColumn4(tileFactory.field.newFieldWithAdditionalInfo('businessType', 'businessTypeDescription'));
            if(rawTileData.attachedManager > 0) {
                tileFactory.addFieldToColumn4(tileFactory.field.newLinkField('attachedManager', 'attachedManagerURI'));
            }
            else{
                tileFactory.addFieldToColumn4(tileFactory.field.newField('attachedManager'));
            }



            tileFactory.addStatus(tileFactory.status.newStatusWithHelpAndClassCode('medallionStatus', 'medallionStatusHelpText'));
            tileFactory.tileData.multinational = rawTileData.multinational
            tileFactory.tileData.multinationalHoverText = objectTilesLabels.multinationalHoverText
            tileFactory.addStatus(tileFactory.status.newLabelStatus('multinational', null));
            tileFactory.addStatus(tileFactory.status.newStatusWithInfoAndStyling('businessStatus', 'statusHelpText', [tileFactory.LOOKUP_VALUE.BUSINESS_STATUS_BOOKING], [], [tileFactory.LOOKUP_VALUE.BUSINESS_STATUS_JOB]));

            // creditStatusDetailsName
            // 'No Restrictions'
            // 'Perm Only'
            // 'High Risk'
            // 'Liquidated'
            // 'Duplicate Account Withdrawn'
            // creditStatus
            // 5229: "Prospective"
            // 5230: "Restricted"
            // 5231: "Approved"
            // 5232: "Stop Listed"
            if (rawTileData.creditStatusDetailsName){
                tileFactory.addStatus(tileFactory.status.newCombinedStatusWithHelp('creditStatus', 'creditStatusDetailsName', 'creditStatusHelpText',
                    // Positives
                    [
                        [
                            tileFactory.LOOKUP_VALUE.CREDIT_STATUS_APPROVED,
                            'No Restrictions'
                        ],
                        [
                            tileFactory.LOOKUP_VALUE.CREDIT_STATUS_APPROVED,
                            'Perm Only'
                        ]
                    ],
                    // Negatives
                    [
                        [
                            tileFactory.LOOKUP_VALUE.CREDIT_STATUS_STOP_LISTED,
                            'Liquidated'
                        ],
                        [
                            tileFactory.LOOKUP_VALUE.CREDIT_STATUS_STOP_LISTED,
                            'Duplicate Account Withdrawn'
                        ]
                    ],
                    // Warnings
                    [
                        [
                            tileFactory.LOOKUP_VALUE.CREDIT_STATUS_APPROVED,
                            'High Risk'
                        ],
                        [
                            tileFactory.LOOKUP_VALUE.CREDIT_STATUS_STOP_LISTED,
                            'Perm Only'
                        ],
                        [
                            tileFactory.LOOKUP_VALUE.CREDIT_STATUS_RESTRICTED,
                            'Perm Only'
                        ]
                    ]
                ));
            }else{
                tileFactory.addStatus(tileFactory.status.newStatusWithHelp('creditStatus', 'creditStatusHelpText',
                    // Positives
                    [tileFactory.LOOKUP_VALUE.CREDIT_STATUS_APPROVED],
                    // Negatives
                    [tileFactory.LOOKUP_VALUE.CREDIT_STATUS_STOP_LISTED],
                    // Warnings
                    [
                        tileFactory.LOOKUP_VALUE.CREDIT_STATUS_STOP_LISTED,
                        tileFactory.LOOKUP_VALUE.CREDIT_STATUS_RESTRICTED
                    ]
                ));
            }

            tileFactory.addStatus(tileFactory.status.newTrueBooleanOrHide('businessUnsubscribed', 'danger'));

            tileFactory.addStatus(tileFactory.status.newFrameworkStatus('businessFrameworkNameHoverText'));
            tileFactory.addStatus(tileFactory.status.newFinancialActivtyStatus('finActivityFlag','finTabURI'));
            tileFactory.addStatus(tileFactory.status.newLabelStatus('targetClient', null));

            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapBusinessrecordTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapBusinessrecordTileService', mapBusinessrecordTileService);
}());
